import { useStaticQuery, graphql } from 'gatsby';

const useHeader = () => {
  const { strapiSite } = useStaticQuery(graphql`
    query StrapiSiteSiteHeaderQuery {
      strapiSite {
        id
        header {
          id
          stickyUntil
          logo {
            id
            justify
            logo {
              id
              name
              url
              width
              height
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    height: 60
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
          nav {
            id
            justify
            beam
            hamburgerUntil
            menu {
              id
            }
          }
          items {
            id
            visibleFrom
            visibleUntil
            iconOnlyUntil
            inCoverNav
            button {
              ...PagebuilderButton
            }
            image {
              id
              image {
                id
                name
                url
                width
                height
                alternativeText
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FIXED
                      height: 40
                      placeholder: BLURRED
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return strapiSite.header;
};

export default useHeader;
